import { styled } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
}));
